var BookingsService = /** @class */ (function () {
    function BookingsService(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * SearchDestinationsAsync
     * @param term
     * @param includeNearby Default: false (adds second array of destinations nearby if true)
     * @param limit Default: 30
     * @param fromIataCode Default: "" (will retrieve valid destinations of selected record)
     * @param includeInactive Default: false (if true, returns locations with LocAvrive = false)
     * @returns any Successful response
     * @throws ApiError
     */
    BookingsService.prototype.getApiV1BookingsAirportsSearch = function (term, includeNearby, limit, fromIataCode, includeInactive) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/bookings/airports/search',
            query: {
                'term': term,
                'includeNearby': includeNearby,
                'limit': limit,
                'fromIataCode': fromIataCode,
                'includeInactive': includeInactive,
            },
        });
    };
    /**
     * GetDestinationsNearbyAsync
     * This call is used to expose functionality using custom location coordinates. To allow MaxMind to detect the coordinates, don't specify any coordinates.
     * @param latitude
     * @param longitude Default: -1
     * @param limit Default: 30
     * @param fromIataCode Default: "" (will retrieve valid destinations of selected record)
     * @param includeInactive Default: false (if true, returns locations with LocAvrive = false)
     * @returns any Successful response
     * @throws ApiError
     */
    BookingsService.prototype.getApiV1BookingsAirportsNearby = function (latitude, longitude, limit, fromIataCode, includeInactive) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/bookings/airports/nearby',
            query: {
                'latitude': latitude,
                'longitude': longitude,
                'limit': limit,
                'fromIataCode': fromIataCode,
                'includeInactive': includeInactive,
            },
        });
    };
    /**
     * GetFlightsAsync
     * @param requestBody
     * @returns any Successful response
     * @throws ApiError
     */
    BookingsService.prototype.postApiV1BookingsFlightsSearch = function (requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/bookings/flights/search',
            body: requestBody,
            mediaType: 'application/json',
        });
    };
    return BookingsService;
}());
export { BookingsService };
